import { TASK_CHAT_MAX } from '@shared/types/tasks';
import { formatNumber } from '@/lib/formatters';

/**
 * SF-T-185: what to say when a comment (as saved, mentions included) is longer than a task comment
 * takes, so the box says so rather than the server cutting it. Null when it fits.
 */
export function commentTooLong(body: string): string | null {
  const length = body.trim().length;
  if (length <= TASK_CHAT_MAX) return null;
  return `Too long for one comment: ${formatNumber(length)} of ${formatNumber(TASK_CHAT_MAX)} characters`;
}
